module.exports = __webpack_public_path__ + "static/media/mobile_development.cb8d3555.svg";